import Image from "next/image"
import Link from "next/link"

const FooterOne = () => {
  return (
    <footer className="footer-area bg-f6ffeb pt-100">
      <div className="container">
        <div
          className="subscribe-box row"
        >
          <div className="col-lg-6 col-md-12">
           
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="subscribe-form">
            </div>
          </div>
        </div>
        <div className="row  justify-content-between">
          <div className="col-lg-2 col-md-6 col-sm-12 mb-3">
            <div className="single-footer-image mb-25 flex-fill">
              <Link href="/" className="logo mb-0 d-inline-block">
                <Image
                  width={182}
                  height={100}
                  src="/images/common/Ashva.png"
                  alt="logo"
                />
              </Link>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
            <div className="single-footer-widget  ">
              <h3 className="fw-medium ">Navi Mumbai Branch</h3>
              <ul className="custom-links p-0 mb-0 list-unstyled">
                <li>
                  <p className="text-start">
                    Office No: 508, Niharika Mirage D, 5th
                    Floor, Plot No. 274, Kharghar, Navi Mumbai
                   - 410210 Maharashtra.
                  </p>
                 
                
                </li>
                
                <li>
                  <div className="map-container   border border-white rounded-2">
              
                           <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d482767.482894252!2d73.078619!3d19.036417!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c355b7c64a25%3A0xc76b2aeb78d35d52!2sAshva%20Education%20Society!5e0!3m2!1sen!2sin!4v1757612298693!5m2!1sen!2sin" height="150"  loading="lazy" 
                  className="border border-white rounded-2"
                  ></iframe>
                  
                  
                  </div>
                </li>
                
                
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
            <div className="single-footer-widget  ">
              <h3 className="fw-medium">Pen Branch</h3>
              <ul className="custom-links p-0 mb-0 list-unstyled">
                <li>
                   <p className="text-start">
                      Gurusankalp Building, Plot Number 66,
                      Mhada Colony, Mumbai - Goa Hwy,
                       Mahamarg, Pen- 402107, brMaharashtra.
                   </p>
                  
                </li>
                
                <li>
                    <div className="map-container border   border-white rounded-2">
                           <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d483608.8681359308!2d73.091011!3d18.744857!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be80ba98a5d0f2b%3A0x1a818df1ee454b5d!2sAshva%20Education%20Of%20Paramedical%20Science%20Pen%20Branch!5e0!3m2!1sen!2sin!4v1757612749441!5m2!1sen!2sin" 
                 className="border border-white rounded-2"
                ></iframe>
                    </div>
                  
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
            <div className="single-footer-widget  ">
              <h3 className="fw-medium">Uran Branch</h3>
              <ul className="custom-links p-0 mb-0 list-unstyled">
                <li>
                   <p className="text-start ">
                      Ashva Education, Bokadvira, near Uran
                       police chowk, Bokadvira Uran- 400702,
                          Maharashtra.
                   </p>
                </li>
                <li>
                     <div className="map-container   border border-white rounded-2 ">
                              <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d30201.30628407752!2d72.957888!3d18.879836000000005!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7dbcf545c8559%3A0xb8ea47dbfbdd9298!2sUran%20Police%20Check%20Post!5e0!3m2!1sen!2sin!4v1757612884149!5m2!1sen!2sin"
                                   className="border border-white rounded-2"
                    ></iframe>
                     </div>
                </li>
               
              </ul>
            </div>
          </div>
        </div>
        <div className="copyright-area border-top pb-5 fs-6">
          <div className="row align-items-center">
            <div className="col-lg-3 col-sm-6">
               <p> <i className="fa-solid fa-phone" /> 91 88796 99323  </p>
              <p className="mb-0">© 2024 Ashva Education. All rights reserved.</p>
            </div>
            <div className="col-lg-6 col-sm-6">
              <ul className="custom-links mb-0 list-unstyled">
                <li className="d-inline-block">
                  <Link href="privacy-policy">Privacy Policy</Link>
                </li>
                <li className="d-inline-block">
                  <Link href="terms-conditions">Terms of Service</Link>
                </li>
                <li className="d-inline-block">
                  <Link href="privacy-policy">Cookies Settings</Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="socials">
                <Link
                  href="https://www.facebook.com/ashvaeducation"
                  className="d-inline-block position-relative rounded-circle text-center"
                >
                  <i className="fa-brands fa-facebook-f" />
                </Link>
                <Link
                  href="https://www.instagram.com/AshvaFoundation31/"
                  className="d-inline-block position-relative rounded-circle text-center"
                >
                  <i className="fa-brands fa-instagram" />
                </Link>
                <Link
                  href="https://wa.me/919876543210"
                  className="d-inline-block position-relative rounded-circle text-center"
                >
                     <i className="fa-brands fa-whatsapp" />
                </Link>
            
                <Link
                  href="mailto:enquiry@ashvaeducation.org.in"
                  className="d-inline-block position-relative rounded-circle text-center"
                >
                  <i className="fa-brands fa-google" />
                </Link>
                <Link
                  href="tel:+91 88796 99323"   
                  className="d-inline-block position-relative rounded-circle text-center"
                  >
                  <i className="fa-solid fa-phone" />   
                 </Link>
                 
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </footer>
  )
}

export default FooterOne
